<p>dialog-check works!</p>
